import React, { useEffect, useState } from "react";
import {
  Card,
  // Form,
  // InputGroup,
  Button,
  Breadcrumb,
  // Pagination,
} from "react-bootstrap";
import imageProfileEmpty from "../../assets/profile-empty.webp";
import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../store/useStore";
import { delete_staff, get_staff } from "../../services/staff.service";
import moment from "moment";
import PopUpConfirmDelete from "../../components/popup/PopUpConfirmDelete";
import { END_IMAGE } from "../../constants";
import converSex from "../../helpers/convertSex";
import { WarningError } from "../../helpers/alertseet";
import cutBranchNo from "../../helpers/cutBranchNo";

export default function DetailStaffPage() {
  const navigate = useNavigate();
  const { staffId } = useParams();
  // state
  const [isLoading, setIsLoading] = useState(true);
  const [staffData, setStaffData] = useState();
  const [popup, setPopup] = useState();

  // store
  const { token, setIsLoadingDetailPage } = useStore();
  // useEffect
  useEffect(() => {
    getData();
  }, []);

  // function
  const getData = async () => {
    try {
      setIsLoading(true);
      setIsLoadingDetailPage(true);
      const data = await get_staff(staffId, token);
      if (data?.error) throw new Error(data?.message);
      let staff = data?.data;

      setStaffData(staff);
      setIsLoading(false);
      setIsLoadingDetailPage(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
      setIsLoadingDetailPage(false);
    }
  };
  const handleDelete = async () => {
    await delete_staff(staffId, token);
    navigate("/staff", { replace: true });
  };
  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => navigate("/staff", { replace: true })}>
          ຈັດການພະນັກງານ
        </Breadcrumb.Item>
        <Breadcrumb.Item active>ລາຍລະອຽດບັນຊີ</Breadcrumb.Item>
      </Breadcrumb>
      <Card
        style={{
          padding: "20px 20px",
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 150,
        }}
      >
        <div style={{ display: "flex", gap: 20, justifyContent: "flex-end" }}>
          <Button
            variant="outline-danger"
            onClick={() => {
              if (staffData.role !== "STAFF") {
                WarningError("ບໍ່ສາມາດລົບບັນຊີນີ້ໄດ້");
                return;
              }
              setPopup({ PopUpConfirmDelete: true });
            }}
            size="md"
          >
            ລຶບ
          </Button>
          <Button
            onClick={() => navigate(`/staff/update/${staffId}`)}
            size="md"
          >
            ແກ້ໄຂ
          </Button>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto 1fr",
            gap: 20,
            gridGap: 20,
            width: "100%",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <h2>ຮູບພາບ</h2>
            <div
              style={{
                borderRadius: 8,
                overflow: "hidden",
                width: 160,
                height: 160,
              }}
            >
              <img
                src={
                  staffData?.profileImage
                    ? END_IMAGE + staffData?.profileImage
                    : imageProfileEmpty
                }
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <h2>ຂໍ້ມູນສ່ວນໂຕ</h2>
            {[
              {
                title: "ເລກພະນັກງານ:",
                value: staffData?.staffNo
                  ? cutBranchNo(staffData?.staffNo)
                  : "-",
              },
              { title: "ຊື່:", value: staffData?.firstName || "-" },
              { title: "ນາມສະກຸນ:", value: staffData?.lastName || "-" },
              {
                title: "ເພດ:",
                value: staffData?.gender ? converSex(staffData?.gender) : "-",
              },
              {
                title: "ວັນເດືອນປີເກີດ:",
                value: staffData?.birthday
                  ? moment(staffData?.birthday).format("YYYY-MM-DD")
                  : "-",
              },
              { title: "ອາຊີບ:", value: staffData?.occupation || "-" },
              { title: "ໜ່ວຍ:", value: staffData?.homeUnit || "-" },
              { title: "ເຮືອນເລກທີ:", value: staffData?.homeNumber || "-" },
              { title: "ເມືອງ:", value: staffData?.district || "-" },
              { title: "ແຂວງ:", value: staffData?.province || "-" },
              {
                title: "ສຳມະໂນຄົວເລກທີ:",
                value: staffData?.familyNumber || "-",
              },
              {
                title: "ລົງວັນທີ:",
                value: moment(staffData?.createdAt).format("YYYY-MM-DD"),
              },
              { title: "ເບີໂທ:", value: staffData?.phone },
            ].map((e, i) => (
              <div className="list-data" key={i}>
                <div>{e?.title}</div>
                <div>{e?.value}</div>
              </div>
            ))}

            <br />
            {/* section ຂໍ້ມູນບັນຊີເຂົ້າໃຊ້ລະບົບ */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <h2>ຂໍ້ມູນບັນຊີເຂົ້າໃຊ້ລະບົບ</h2>
              {[
                { title: "ເລກໄອດີຜູ້ໃຊ້:", value: staffData?.userName || "-" },
                { title: "ລະຫັດຜ່ານ:", value: "••••••••••" },
                { title: "ຕຳແໜ່ງ:", value: staffData?.role || "-" },
                {
                  title: "ວັນທີສ້າງ:",
                  value: moment(staffData?.createdAt).format("YYYY-MM-DD"),
                },
                {
                  title: "ຜູ້ສ້າງບັນຊີ:",
                  value: staffData?.createdBy?.fullName || "-",
                },
              ].map((e, i) => (
                <div className="list-data" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
            <br />
            <br />
          </div>
        </div>
        {/* <div style={{ display: "flex", gap: 20, justifyContent: "flex-end" }}>
          <Button
            variant="outline-danger"
            onClick={() => {
              if (staffData.role != "STAFF") {
                WarningError("ບໍ່ສາມາດລົບບັນຊີນີ້ໄດ້");
                return;
              }
              setPopup({ PopUpConfirmDelete: true });
            }}
            size="md"
          >
            ລຶບ
          </Button>
          <Button
            onClick={() => navigate(`/staff/update/${staffId}`)}
            size="md"
          >
            ແກ້ໄຂ
          </Button>
        </div> */}
      </Card>
      {/* popup */}
      <PopUpConfirmDelete
        open={popup?.PopUpConfirmDelete}
        onClose={() => setPopup()}
        onSubmit={handleDelete}
        title={"ລຶບບັນຊີ!"}
        sub={
          <span>
            ທ່ານຕ້ອງການລຶບບັນຊີ{" "}
            <span style={{ fontWeight: 700 }}>{staffData?.fullName}</span>{" "}
            ນີ້ແທ້ບໍ່?
          </span>
        }
      />
    </div>
  );
}
